import { addDataBoxTestHistory, getDataBoxTestByDataBoxId } from "@/api/device/data-box"
import { testDataBoxConnect } from "@/api/monitoring/monitoring"
import { TEST_RETURN_STATUS } from "@/enums/test-return-status"
import TnMessage from "@/global/components/message"
import { DataBox } from "@/global/interface/device/data-box"
import { DeviceTestConnectHistory } from "@/global/interface/device/sensor"
import { Spin } from "antd"
import { useEffect, useState } from "react"
import { useParams } from "react-router"

interface Iprops {
    dataBox: DataBox
}

export default function DataBoxCheckPanel(props: Iprops) {
    const [testHistoryList, setTestHistoryList] = useState<DeviceTestConnectHistory[]>([])

    const [isTesting, setIsTesting] = useState<boolean>(false)

    const { projectId } = useParams()

    const { dataBox } = props

    useEffect(() => {
        if (dataBox) {
            generateData()
        }
    }, [dataBox])

    const generateData = () => {
        // getSensorTestBySensorId(sensor.id).then(res => {
        getDataBoxTestByDataBoxId(dataBox.id).then(res => {
            let list: DeviceTestConnectHistory[] = res?.data || []
            list.sort((a, b) => a.testTime - b.testTime)
            setTestHistoryList(list)
        })
    }

    const startTest = () => {
        if (!dataBox) return
        if (dataBox.start) {
            TnMessage.warning("请关闭设备后再进行测试")
            return
        }
        setIsTesting(true)
        testDataBoxConnect(dataBox.id).then(res => {
            let resStatus = res.data
            let checkStr = ""
            if (resStatus == TEST_RETURN_STATUS.SUCESS) {
                checkStr = "心跳包正常。"
            } else {
                checkStr = "未监听到心跳包。"
            }
            let testReocrd = "用户对" + (dataBox?.name || "采集箱") + "进行了测试，" + checkStr
            addDataBoxTestHistory(Number(projectId), dataBox.id, { detail: testReocrd }).then(res => {
                generateData()
            })
        }).finally(() => {
            setIsTesting(false)
        })

    }
    return (
        <div className="check-main">
            <div className="title">
                测试
            </div>
            <div className="btn-area">
                {isTesting ? (
                    <div className="loading-area">
                        <Spin />
                    </div>
                ) : (
                    <div className="check-btn" onClick={() => { startTest() }}>
                        开始测试
                    </div>
                )}
            </div>
            <div className="report-list">
                {testHistoryList?.map((item, index) => (
                    <div className="list-item">
                        <div className="label">
                            {"测试记录" + (index + 1)}
                        </div>
                        <div className="value">
                            {item.detail}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}